import { render, staticRenderFns } from "./pingTest.vue?vue&type=template&id=72901c2b&scoped=true"
import script from "./pingTest.vue?vue&type=script&lang=js"
export * from "./pingTest.vue?vue&type=script&lang=js"
import style0 from "./pingTest.vue?vue&type=style&index=0&id=72901c2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72901c2b",
  null
  
)

export default component.exports